import { render, staticRenderFns } from "./AddNewTable.vue?vue&type=template&id=9e6b28d4"
import script from "./AddNewTable.vue?vue&type=script&lang=js"
export * from "./AddNewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e6b28d4')) {
      api.createRecord('9e6b28d4', component.options)
    } else {
      api.reload('9e6b28d4', component.options)
    }
    module.hot.accept("./AddNewTable.vue?vue&type=template&id=9e6b28d4", function () {
      api.rerender('9e6b28d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/AddNewTable.vue"
export default component.exports